export const getWeatherBackground = (weatherCode, isNight = false) => {
  // Weather code groups from OpenWeatherMap
  // 2xx: Thunderstorm, 3xx: Drizzle, 5xx: Rain, 6xx: Snow
  // 7xx: Atmosphere, 800: Clear, 80x: Clouds

  const code = Math.floor(weatherCode / 100);

  if (isNight) {
    return {
      background:
        "linear-gradient(135deg, #0c0c1e 0%, #1a1a3e 50%, #2d2d5a 100%)",
      className: "night",
    };
  }

  switch (code) {
    case 2: // Thunderstorm
      return {
        background:
          "linear-gradient(135deg, #373b44 0%, #4286f4 50%, #373b44 100%)",
        className: "stormy",
      };
    case 3: // Drizzle
    case 5: // Rain
      return {
        background: "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
        className: "rainy",
      };
    case 6: // Snow
      return {
        background: "linear-gradient(135deg, #e6dada 0%, #274046 100%)",
        className: "snowy",
      };
    case 7: // Atmosphere (fog, mist, etc.)
      return {
        background: "linear-gradient(135deg, #757f9a 0%, #d7dde8 100%)",
        className: "foggy",
      };
    case 8:
      if (weatherCode === 800) {
        // Clear sky
        return {
          background:
            "linear-gradient(135deg, #56ccf2 0%, #2f80ed 50%, #667eea 100%)",
          className: "sunny",
        };
      } else {
        // Clouds
        return {
          background: "linear-gradient(135deg, #bdc3c7 0%, #2c3e50 100%)",
          className: "cloudy",
        };
      }
    default:
      return {
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        className: "default",
      };
  }
};

export const isNightTime = (sunrise, sunset) => {
  const now = Date.now() / 1000; // Current time in seconds
  return now < sunrise || now > sunset;
};
